import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = () => {
    return (
<div className="navigation">
    <ul>
        <li>
            <NavLink to="/"className={(nav) => (nav.isActive ? "nav-active" : "")}>
                Pokédex
            </NavLink>
            <NavLink to="/gmax"className={(nav) => (nav.isActive ? "nav-active" : "")}>
                Gigamax
            </NavLink>
            <NavLink to="/mega"className={(nav) => (nav.isActive ? "nav-active" : "")}>
                Mega
            </NavLink>
            <NavLink to="/Contact"className={(nav) => (nav.isActive ? "nav-active" : "")}>
                Contact
            </NavLink>
        </li>
    </ul>
    <div className="App">
 </div>
</div>

    );
};

export default Navigation;